import React from "react";

const ReactBarsLoader: React.FC = () => {
  return (
    <div className="bars-loader">
      <div className="bar " />
      <div className="bar " />
      <div className="bar " />
      <div className="bar " />
    </div>
  );
};

export default ReactBarsLoader;
